class PurchaseOrderController extends AbstractEntityEditController
	@register()
	@inject '$state',
		'$scope'
		'$timeout'
		'translate'
		'purchaseOrder'
		'shops'
		'stockLocations'
		'suppliers'
		'priceRegions'
		'MessageTerminal'
		'PurchaseOrderService'
		'PurchaseOrderRepository'
		'PurchaseOrderFormatService'
		'RenderRepository'
		'DATE_FORMAT'
		'PURCHASE_ORDER'
		'ConfigurationService'

	initialize: ->
		@isXeroEnabled = @ConfigurationService.isEnabled 'Backoffice.Setting.Integrations.Xero.Enabled'

		if _.isEmpty @purchaseOrder
			@mainCrud.entityTitle = 'general.loading'
			return

		@purchaseOrder.price_region_id = @purchaseOrder.shop?.price_region_id ? null

		if !@purchaseOrder.price_region_id? && @priceRegions.length == 1
			@purchaseOrder.price_region_id = @priceRegions[0].id

		# Remove deleted products
		@purchaseOrder.line_items = @purchaseOrder.line_items.filter((lineItem) => lineItem.product?)
		@purchaseOrder.line_items.sort (a, b) =>
			if a.product.name == b.product.name
				return ('' + a.product_variant?.name).localeCompare('' + b.product_variant?.name, undefined , {numeric: true, sensitivity: 'base'})

			return ('' + a.product.name).localeCompare('' + b.product.name, undefined , {numeric: true, sensitivity: 'base'})
		@deliveryTypes = @PurchaseOrderService.getDeliveryTypes()
		@settings =
			isNewEntity: false
			showAsReport: false
			isLocked: true
			completionFieldsAreLocked: true
		@stockLocationName = @getName @stockLocations, @purchaseOrder.stock_location_id
		@shopName = @getName @shops, @purchaseOrder.shop_id
		@supplierName = @getName @suppliers, @purchaseOrder.supplier_id
		@confirmCompleteText = @translate('general.purchase_order.confirm.complete', {buttonText: @translate('general.purchase_order.status.action.complete')})

		@datePickerInfo =
			expected_delivery_time:
				singleDatePicker: true
				startDate: moment.unix(@purchaseOrder.expected_delivery_time)
				minDate: moment()
			delivery_time:
				singleDatePicker: true
				startDate: moment.unix(if @purchaseOrder.delivery_time then @purchaseOrder.delivery_time else @purchaseOrder.expected_delivery_time)
				minDate: moment()
			invoice_time:
				singleDatePicker: true
				minDate: moment()

		@mainCrud.tabs = [
			{
				active: true
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'general.products'
				selector: '#tab-products'
			}
		]
		@mainCrud.entityType = 'general.purchase_order'
		@mainCrud.entityTitle = @purchaseOrder.name
		@mainCrud.showFormActionButtons = !@settings.isLocked
		@mainCrud.isNewEntity = false

	onDeliveryTimeChange: ->
		if @settings.isCompletionInProcess
			@purchaseOrder.delivery_time = @datePickerInfo.delivery_time.startDate.unix()

	save: (title = 'alert.updated') ->
		@onDeliveryTimeChange()

		lineItems = []

		for lineItem in @purchaseOrder.line_items
			if !lineItem.selected || parseFloat(lineItem.requested_quantity) <= 0
				lineItem.deleted = true

				if !lineItem.id?
					continue

			if lineItem.cost_price == null
				lineItem.cost_price = lineItem.actual_cost_price

			lineItems.push lineItem

		@purchaseOrder.line_items = lineItems

		@PurchaseOrderService
			.save(@purchaseOrder, true)
			.then (response) =>
				@purchaseOrder.revision_number = response.data.revision_number

				for responseLineItem in response.data.line_items
					lineItem = _.find(
						@purchaseOrder.line_items,
						{
							product_id: responseLineItem.product_id,
							product_variant_id: responseLineItem.product_variant_id
						}
					)

					if lineItem
						lineItem.dirty = false
						lineItem.id = responseLineItem.id
						lineItem.requested_quantity = responseLineItem.requested_quantity

				@purchaseOrder.line_items = _.reject(@purchaseOrder.line_items, {deleted: true})

				@settings.isCompletionInProcess = false

				@MessageTerminal.publish @MessageTerminal.events.PURCHASE_ORDER.REPORT_DATA, @PurchaseOrderFormatService.purchaseOrderToReport @purchaseOrder
				@afterSave response, undefined, undefined, undefined, title
			.catch (response) =>
				@handleErrors response
			.finally =>
				@resetStatus()

	delete: ->
		@PurchaseOrderRepository
			.delete(@purchaseOrder.id)
			.then (response) =>
				@afterDelete @purchaseOrder
				# Timeout is needed to allow current state change to be completed before going to next one.
				# See https://stackoverflow.com/a/44654316/9654875 for more information.
				@$timeout (() => @$state.go 'reports.purchase_orders', 1000)
			.catch (response) =>
				@handleErrors response
			.finally =>
				@resetStatus()

	cancel: ->
		@mainCrud.saving = true
		@PurchaseOrderRepository
			.patch @purchaseOrder.id, {status: @PURCHASE_ORDER.STATUS.CANCELLED}
			.then (response) =>
				@purchaseOrder.status = response.data.status
				@settings.completionFieldsAreLocked = true

				@afterSave response, undefined, undefined, undefined, 'general.purchase_order.status.cancelled'
			.catch (response) =>
				@handleErrors response
			.finally =>
				@resetStatus()

	complete: ->
		@save 'general.purchase_order.status.completed'

	initCompletion: ->
		@settings.isCompletionInProcess = true
		@settings.completionFieldsAreLocked = false
		@purchaseOrder.status = @PURCHASE_ORDER.STATUS.COMPLETED
		@purchaseOrder.delivery_time = Math.max @purchaseOrder.expected_delivery_time, moment().unix()
		@mainCrud.showFormActionButtons = true
		@mainCrud.showSave = false
		@mainCrud.showDelete = false
		@mainCrud.additionalButtons = [
			{
				action: 'complete'
				label: 'general.purchase_order.status.action.complete'
				click: => @complete()
				disabled: @mainCrud.parent_form.$invalid
			}
		]
		@$scope.$watch 'mainCrud.parent_form.$invalid',
			=>
				@mainCrud.additionalButtons[0]?.disabled = @mainCrud.parent_form.$invalid

	getName: (entities, id) ->
		if not id?
			return null

		entity = _.find entities, {id: id}

		return entity.name if entity?
		return "#{@translate('general.deleted')} (#{id})"

	unlock: ->
		@settings.isLocked = false
		@mainCrud.showFormActionButtons = !@settings.isLocked

	resetStatus: ->
		@settings.isLocked = true
		@mainCrud.showFormActionButtons = !@settings.isLocked
		@settings.isCompletionInProcess = false
		@settings.completionFieldsAreLocked = true
